import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section } from "@/components/kit";
import { SERVICE_LINKS, COUNTRY_LINKS, CASE_CARDS, ARTICLES } from "@/lib/content";

const GROUPS = [
  { title: "Main", links: [["Home", "/"], ["Services", "/services"], ["Pricing", "/pricing"], ["About", "/about"], ["Vision", "/vision"], ["Case studies", "/case-studies"], ["Insights", "/insights"], ["Tools", "/tools"], ["Sourcing", "/sourcing"], ["FAQ", "/faq"], ["Book a fit call", "/book"], ["Contact", "/contact"]] },
  { title: "Services", links: SERVICE_LINKS.map((s) => [s.title, `/services/${s.slug}`]) },
  { title: "Sourcing", links: COUNTRY_LINKS.map((c) => [`Sourcing from ${c.name}`, `/sourcing/${c.slug}`]) },
  { title: "Case studies", links: CASE_CARDS.map((c) => [c.label, `/case-studies/${c.slug}`]) },
  { title: "Insights", links: ARTICLES.map((a) => [a.title, `/insights/${a.slug}`]) },
  { title: "Tools & guides", links: [["Landed cost & margin calculator", "/tools/landed-cost-and-margin-calculator"], ["Free downloads", "/tools/downloads"], ["First production run guide", "/guides/first-production-run-australia"]] },
  { title: "Legal", links: [["Privacy policy", "/privacy-policy"], ["Terms of engagement", "/terms"]] },
];

export default function Sitemap() {
  return (
    <>
      <Seo title="Sitemap" canonical="/sitemap" description="Every page on the Prox website." />
      <PageHero eyebrow="Sitemap" crumbs={[{ label: "Home", to: "/" }, { label: "Sitemap" }]} title="Everything on the site." />
      <Section bg="bone">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <p className="eyebrow">{g.title}</p>
              <ul className="mt-5 space-y-2.5 t-sm">
                {g.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="lnk">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
